module.exports = __webpack_public_path__ + "static/media/logoBLL.70c41415.png";